import type { HTMLAttributes } from 'vue'

type ClassValue =
  | HTMLAttributes['class']
  | Record<string, boolean | null | undefined>
  | false
  | null
  | undefined

export function cn(...classes: ClassValue[]) {
  return classes.flatMap(classNames).filter(Boolean).join(' ')
}

function classNames(className: ClassValue): string[] {
  if (!className) {
    return []
  }

  if (typeof className === 'string') {
    return [className]
  }

  if (Array.isArray(className)) {
    return className.flatMap((name) => classNames(name as ClassValue))
  }

  return Object.entries(className)
    .filter(([, enabled]) => enabled)
    .map(([name]) => name)
}
